import React from 'react';

interface FloatingVoiceAssistantProps {
  onOpenChat: () => void;
  onStartVoice: () => void;
  isVoiceActive: boolean;
  isListening?: boolean;
  isSpeaking?: boolean;
  codePanelOpen?: boolean;
  chatPanelOpen?: boolean;
}

const FloatingVoiceAssistant: React.FC<FloatingVoiceAssistantProps> = ({
  onOpenChat,
  onStartVoice,
  isVoiceActive,
  isListening = false,
  isSpeaking = false,
  codePanelOpen = false,
  chatPanelOpen = false,
}) => {
  const handleToggle = () => {
    if (!isVoiceActive) {
      // Start voice in background (without opening chat)
      onStartVoice();
    } else {
      // Stop voice
      onStartVoice();
    }
  };

  const getTitle = () => {
    if (!isVoiceActive) return 'Zapnout hlasového asistenta';
    return 'Vypnout hlasového asistenta';
  };

  const chatOffset = 'calc(min(36rem, 40vw) + 1.25rem)';

  const getPosition = (): React.CSSProperties => {
    if (chatPanelOpen) {
      return { right: chatOffset, left: 'auto' };
    }
    if (codePanelOpen) {
      return { left: 'calc(66.666667% + 1rem)', right: 'auto' };
    }
    return { right: '1rem', left: 'auto' };
  };

  return (
    <div
      className="fixed bottom-4 z-[60] transition-all duration-300"
      style={getPosition()}
    >
      {/* Voice assistant button - small, no background, icon only */}
      <button
        onClick={handleToggle}
        className="w-8 h-8 flex items-center justify-center transition-all duration-300 hover:scale-110"
        title={getTitle()}
      >
        <svg
          className={`w-7 h-7 transition-all duration-300 ${
            isVoiceActive
              ? 'text-gray-700 dark:text-gray-300'
              : 'text-gray-400 dark:text-gray-500 opacity-60'
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isVoiceActive ? (
            // Active microphone
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
          ) : (
            // Muted microphone with slash
            <>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 10v1c0 3.866-3.134 7-7 7s-7-3.134-7-7v-1" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18v4m-4 0h8" />
              <line strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} x1="4" y1="4" x2="20" y2="20" />
            </>
          )}
        </svg>
      </button>
    </div>
  );
};

export default FloatingVoiceAssistant;
